import './VisuallyHidden-ce2a3270.css';

var classes = {"VisuallyHidden":"prc-VisuallyHidden-VisuallyHidden-UNWQp"};

export { classes as default };
